module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/si-d38938fcbf4ff943085655e60cd4899d.svg";